export default __webpack_public_path__ + "navigation-camera-geometry-framing-after-maneuver-enabled-1200-9b869a55a6a07956af99aa1d8512e919.webp";